import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import LabeledCheckbox from '../LabeledCheckbox.jsx';

import { setProjectFilterFloat, setProjectFilterApplyFloatFilter } from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByFloat = () => {
	const [{ datasets, currentDataset, projectFilter }, dispatch] = useStateValue();
	const datasetInfo = currentDataset && datasets ? datasets[currentDataset] : null;
	if (!datasetInfo) {
		return null;
	}
	const { filterOptions } = datasetInfo;
	if (!filterOptions?.totalFloat) {
		return null;
	}

	const handleApplyFloatFilterChange = e => {
		const applying = e.target.checked;
		if (applying && projectFilter.floatMin === 0 && projectFilter.floatMax === 0) {
			dispatch(setProjectFilterFloat(
				filterOptions.totalFloat.min,
				filterOptions.totalFloat.max
			));
		}
		dispatch(setProjectFilterApplyFloatFilter(applying));
	};

	const handleSliderChange = value => {
		dispatch(setProjectFilterFloat(value[0], value[1]));
	};

	const handleFloatMinChange = e => {
		dispatch(setProjectFilterFloat(+e.target.value, projectFilter.floatMax));
	};

	const handleFloatMaxChange = e => {
		dispatch(setProjectFilterFloat(projectFilter.floatMin, +e.target.value));
	};

	return (
		<Panel
			className={classnames({activeFilter: projectFilter.applyFloatFilter})}>
			<Panel.Heading>
				<Panel.Title toggle>Float</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<LabeledCheckbox
						text="Apply Float Filter"
						checked={projectFilter.applyFloatFilter}
						onChange={handleApplyFloatFilterChange} />
					<input
						className="sliderValueInput sliderValueInput-min"
						type="number"
						value={projectFilter.floatMin}
						onChange={handleFloatMinChange}
						onFocus={e => { e.target.select(); }} />
					<input
						className="sliderValueInput sliderValueInput-max"
						type="number"
						value={projectFilter.floatMax}
						onChange={handleFloatMaxChange}
						onFocus={e => { e.target.select(); }} />
					<Slider
						range
						allowCross={false}
						onChange={handleSliderChange}
						min={filterOptions.totalFloat.min}
						max={filterOptions.totalFloat.max}
						value={[projectFilter.floatMin, projectFilter.floatMax]} />
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByFloat;
